




































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import Product from "@/modules/plushie/product.model";

import FactoryRushCapacitySlot from "../../factory-rush-capacity-slot.model";
import FactoryRushCapacityType from "../../factory-rush-capacity-type.model";

@Component
export default class FactoryRushCapacityViewForm extends Vue {
  @Prop({ required: true })
  public readonly configuredSlots!: FactoryRushCapacitySlot[];

  @Prop({ required: true })
  public readonly products!: Product[];

  @Prop({ required: true })
  public readonly types!: FactoryRushCapacityType[];

  get columnWidth(): string {
    const columnsCount = this.types.length ? this.types.length : 1;
    const value = Math.round((80 * 100) / columnsCount) / 100;

    return value.toString() + "%";
  }

  public getCapacityValue(productId: string, typeId: string): string {
    const slot = this.configuredSlots.find(
      (item) =>
        item.product.toString() === productId.toString() &&
        item.type.toString() === typeId.toString()
    );

    return slot ? slot.capacity.toString() : "";
  }
}
